/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_Search_PropertyInputs */

const cs_templates_use_picker_search_property = /** @type {(inputs: Templates_Use_Picker_Search_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat inzerát…`)
};

const en_templates_use_picker_search_property = /** @type {(inputs: Templates_Use_Picker_Search_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search listings…`)
};

/**
* | output |
* | --- |
* | "Search listings…" |
*
* @param {Templates_Use_Picker_Search_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_search_property = /** @type {((inputs?: Templates_Use_Picker_Search_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_Search_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_search_property(inputs)
	return cs_templates_use_picker_search_property(inputs)
});